import { render } from "./Tab3Feedback.vue?vue&type=template&id=5a61e483"
import script from "./Tab3Feedback.vue?vue&type=script&lang=ts"
export * from "./Tab3Feedback.vue?vue&type=script&lang=ts"
script.render = render

export default script